// Columnas del head por defecto
export const defaultFields = () => {
    return [
        {
            key: 'number_tank',
            label: 'N.Tanque',
            sortable: true
        },
        {
            key: 'location',
            label: 'Ubicación',
            sortable: true
        },
        {
            key: 'quantity',
            label: 'Cantidad',
            sortable: true
        },
        {
            key: 'unit_of_measure',
            label: 'Und.Volumen',
            sortable: true
        },
        {
            key: 'is_active',
            label: 'Estado',
            sortable: true
        },
        {
            key: 'actions',
            label: 'Acciones'
        },
    ];
}

// Configuración de la tabla (head, body)
export const dataConfigTable = () => {
    return {
        fields: defaultFields(),
        items: [],
        data: {
            total: 0
        }
    }
}

// Información inicial para los filtros y paginación.
export const dataInitialModal = () => {
    return {
        isOpen: false,
        action: 'CREATE',
        title: 'Crear tanques'
    }
}

// Información inicial el tanque seleccionado.
export const dataSelectedTank = () => {
    return {
        id: null,
        number_tank: '',
        quantity: 0,
        unit_of_measure: '',
        location_id: null,
        volume_unit_id: null,
        is_active: true,
        prod_product_id: null,
        is_active: 1
    }
}

// Filtros y paginación
export const defaultParamsFilter = () => {
    return {
        company_id: null,
        locationId: null,
        filter: null,
        paginate: 1,
        page: 1,
        per_page: 10
    };
};

export default {
    loadingDataTable: false,
    modal: dataInitialModal(),
    tableConfig: dataConfigTable(),
    selectedTank: dataSelectedTank(),
    filter: defaultParamsFilter(),
    unitOfMeasures: []
}
